import { useFilterModulesStore } from 'components/filter/filters-next/filterModules';
import { FilterCacheModule, ServerKey } from 'components/filter/types';

const getUpstream = (key: ServerKey) => storeAccessorFactory('upstream')(key);
const getDownstream = (key: ServerKey) => storeAccessorFactory('downstream')(key);
const getPreprocessDownstream = (key: ServerKey) =>
    storeAccessorFactory('preprocessDownstream')(key);
const getPreprocessUpstream = (key: ServerKey) => storeAccessorFactory('preprocessUpstream')(key);

const storeAccessorFactory =
    <T extends keyof FilterCacheModule>(prop: T) =>
    (key: ServerKey) =>
        useFilterModulesStore.getState().modules[key]?.[prop];

export { getUpstream, getPreprocessUpstream, getDownstream, getPreprocessDownstream };
